import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-image-modal',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
  template: `
    @if (data.confirmDelete) {
      <h2 mat-dialog-title>{{ 'GLOBAL.DELETE_IMAGE' | translate }}</h2>
      <mat-dialog-content>
        {{ 'GLOBAL.CONFIRM_DELETE_IMAGE' | translate }}
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="dialogRef.close(false)">{{ 'GLOBAL.CANCEL' | translate }}</button>
        <button mat-button color="warn" (click)="dialogRef.close(true)">{{ 'GLOBAL.DELETE' | translate }}</button>
      </mat-dialog-actions>
    } @else {
      <div class="image-modal">
        <img [src]="data.imagePath" alt="Full-size image" />
      </div>
    }
  `,
  styles: [`
    .image-modal {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
    .image-modal img {
      max-width: 100%;
      max-height: 100%;
    }
  `]
})
export class ImageModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { imagePath?: string; confirmDelete?: boolean },
    public dialogRef: MatDialogRef<ImageModalComponent>
  ) { }
}